import { useEffect, useState } from "react"

import { FieldData, mapFilters } from "@/components/_Shared/FilterWrapper"

import { useCustomerClientsQuery } from "@/hook/CustomerClients/useCustomerClientQuery"
import { useFilterStorage } from "@/hook/useFilterStorage"

import { CUSTOMERS_KEY } from "@/types/ICustomer"
import { FilterField, FilterFieldOperator, FilterFieldType } from "@/types/ui"


export const useCustomerFilters = () => {
  const [filters, setFilters] = useState<FilterField[]>([])

  const { getFilter } = useFilterStorage({
    key: CUSTOMERS_KEY
  })

  const oldFilters: FieldData[] = getFilter()

  const { data: customerClients } = useCustomerClientsQuery()

  useEffect(() => {
    setFilters([
      ...CustomerFilters,
      {
        text: "Клиент",
        name: "CustomerClientId",
        type: FilterFieldType.Select,
        values: customerClients?.response.data
      }
    ])
  }, [customerClients])

  return mapFilters(filters, oldFilters)
}

const CustomerFilters: FilterField[] = [
  {
    text: "Наименование контрагента",
    name: "name",
    type: FilterFieldType.Text,
    operator: FilterFieldOperator.Contains
  },
  {
    text: "Баланс",
    name: "balance",
    type: FilterFieldType.NumberWithOperator
  },
  {
    text: "Сумма заказов в работе",
    name: "sumOrder",
    type: FilterFieldType.NumberWithOperator
  },
  {
    text: "Сумма доступная для заказа",
    name: "availableSum",
    type: FilterFieldType.NumberWithOperator
  },
  {
    text: "Дневной лимит",
    name: "dayLimit",
    type: FilterFieldType.NumberWithOperator
  },
  {
    text: "ИНН",
    name: "inn",
    type: FilterFieldType.Text,
    operator: FilterFieldOperator.Contains
  }
]